import type { DocTypeSchema } from "./meta";
import type { ChildTableRow } from "@/components/child-table/types";

/**
 * Prepare document for save by cleaning child tables
 * 
 * This is the SINGLE SOURCE OF TRUTH for preparing documents before saving.
 * Removes all internal state fields from child tables.
 * 
 * @param doc - Document data to prepare
 * @param metaSchema - DocType metadata
 * @returns Cleaned document ready for save
 */
export function prepareDocForSave(
  doc: Record<string, any>,
  metaSchema: DocTypeSchema
): Record<string, any> {
  const cleaned = { ...doc };
  
  // Find all Table fields from metadata (direct, no tab walking)
  const tableFields = metaSchema.fields.filter(
    (field) => field.fieldtype === "Table"
  );
  
  // Process each child table
  for (const field of tableFields) {
    const tableData = cleaned[field.fieldname];
    
    if (Array.isArray(tableData)) {
      cleaned[field.fieldname] = tableData
        .filter((row: ChildTableRow) => !row.__deleted) // Remove deleted rows
        .map((row: ChildTableRow) => {
          // Remove ALL internal state fields (single place, no duplication)
          const { __state, __originalData, __deleted, _localId, ...rest } = row;
          return rest;
        });
    }
  }
  
  return cleaned;
}

